<template>
  <el-container class="home-container" :dir="lang == 2 ? 'rtl' : 'ltr'">
    <!-- 侧边栏 -->
    <el-aside :width="isCollapse ? '64px' : '265px'" class="hidden-xs-only">
      <div class="totle">
        <img src="../assets/logo.png" alt />
        <span class="notranslate">{{ username }}</span>
      </div>
      <div class="totle2" translate="no">
        {{ langData.agentID }}: <span>{{ code }}</span>
      </div>
      <div class="homebtn">
        <el-button
          class="homebtn1"
          type="primary"
          @click="mCopyUrl"
          size="mini"
        >
          {{ langData.copy }}
        </el-button>
        <el-button class="homebtn1" type="warning" @click="goEdit" size="mini">
          {{ langData.changePassword }}
        </el-button>
      </div>
      <!-- 侧边栏菜单区 -->
      <el-menu
        background-color="#333744"
        text-color="#fff"
        active-text-color="#409Eff"
        unique-opened
        :collapse="isCollapse"
        :collapse-transition="false"
        router
        :default-active="activePath"
        :class="{ ar: lang == 2 }"
      >
        <!-- 一级菜单 -->
        <el-submenu
          :index="item.id + ''"
          v-for="item in menulist"
          :key="item.id"
        >
          <template slot="title">
            <i :class="iocnsObj[item.id]"></i>
            <span>{{ item.authName }}</span>
          </template>
          <!-- 二级菜单 -->
          <el-menu-item
            :index="subItem.path"
            v-for="subItem in item.children"
            :key="subItem.id"
            @click="saveNavState(subItem.path)"
          >
            <i class="el-icon-menu"></i>
            <span>{{ subItem.authName }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>

    <el-container>
      <!-- 头部主题区 -->
      <el-header>
        <div class="time-wrapper-small hidden-sm-and-up">
          <div class="items">
            <span>{{ langData.nextTommorrow }}：</span>
            <div class="statistic-wrapper">
              <el-statistic
                :value-style="{ color: '#fff' }"
                :format="dayCountdownFormat"
                :value="nextDay"
                time-indices
              ></el-statistic>
            </div>
          </div>
          <div class="items">
            <span>{{ langData.nextWeek }}：</span>
            <div class="statistic-wrapper">
              <el-statistic
                :value-style="{ color: '#fff' }"
                :format="weekCountdownFormat"
                :value="nextWeek"
                time-indices
              ></el-statistic>
            </div>
          </div>
        </div>
        <div class="smallshow hidden-sm-and-up">
          <div class="toggle-button hidden-sm-and-up" @click="toggleCollapse">
            |||
          </div>
          <div style="display: flex; align-items: center">
            <el-select v-model="lang" filterable @change="switchLang">
              <el-option label="中文" :value="1"> </el-option>
              <el-option label="English" :value="0"> </el-option>
              <el-option label="ar" :value="2"> </el-option>
              <el-option label="es" :value="3"> </el-option>
            </el-select>
            <el-button type="info" class="heald-btn" @click="logout">
              {{ langData.logout }}
            </el-button>
          </div>
        </div>
        <div class="time-container hidden-sm-and-down">
          <div class="time-wrapper">
            <span>{{ langData.nextTommorrow }}：</span>
            <div class="statistic-wrapper">
              <el-statistic
                :format="dayCountdownFormat"
                :value-style="{ color: '#fff' }"
                :value="nextDay"
                time-indices
              ></el-statistic>
            </div>
            <span>{{ langData.nextWeek }}：</span>
            <div class="statistic-wrapper">
              <el-statistic
                :value-style="{ color: '#fff' }"
                :format="weekCountdownFormat"
                :value="nextWeek"
                time-indices
              ></el-statistic>
            </div>
          </div>
        </div>
        <div class="hidden-sm-and-down">
          <el-select v-model="lang" filterable @change="switchLang">
            <el-option label="中文" :value="1"> </el-option>
            <el-option label="English" :value="0"> </el-option>
            <el-option label="ar" :value="2"> </el-option>
            <el-option label="es" :value="3"> </el-option>
          </el-select>
          <el-button type="info" class="heald-btn" @click="logout">
            {{ langData.logout }}
          </el-button>
        </div>
      </el-header>
      <!-- 右侧主题区 -->
      <el-main
        :class="$store.state.bootstrapResponsive == 'xs' ? 'el-main-xs' : ''"
      >
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </el-main>
    </el-container>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div v-for="(item, i) in list" :key="i" class="div">
        <div>{{ i + 1 }} .</div>
        <div>
          <span>时间: {{ item.date }}</span>
          <div>内容: {{ item.agentInformText }}</div>
        </div>
      </div>
    </el-dialog>
    <el-drawer
      custom-class="drawer-mecss"
      :visible.sync="drawer"
      :direction="direction"
      :withHeader="false"
      size="265px"
    >
      <div class="xs-menu">
        <div class="totle">
          <img src="../assets/logo.png" alt />
          <span>{{ username }}</span>
        </div>
        <div class="totle2">
          {{ langData.agentID }}: <span translate="no">{{ code }}</span>
        </div>
        <div class="homebtn">
          <el-button
            class="homebtn1"
            type="primary"
            @click="mCopyUrl"
            size="mini"
          >
            {{ langData.copy }}
          </el-button>
          <el-button
            class="homebtn1"
            type="warning"
            @click="goEdit"
            size="mini"
          >
            {{ langData.changePassword }}
          </el-button>
        </div>
        <!-- 侧边栏菜单区 -->
        <el-menu
          :class="{ ar: lang == 2 }"
          background-color="#333744"
          text-color="#fff"
          active-text-color="#409Eff"
          unique-opened
          :collapse="isCollapse"
          :collapse-transition="false"
          router
          :default-active="activePath"
        >
          <!-- 一级菜单 -->
          <el-submenu
            :index="item.id + ''"
            v-for="item in menulist"
            :key="item.id"
          >
            <template slot="title">
              <i :class="iocnsObj[item.id]"></i>
              <span>{{ item.authName }}</span>
            </template>
            <!-- 二级菜单 -->
            <el-menu-item
              :index="subItem.path"
              v-for="subItem in item.children"
              :key="subItem.id"
              @click="saveNavState(subItem.path, 2)"
            >
              <i class="el-icon-menu"></i>
              <span>{{ subItem.authName }}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
    </el-drawer>
  </el-container>
</template>

<script>
import { homeLang } from '@/utils/lang.js'
import { count_unreadMsg, query_unreadMsg } from '@/api/login.js'
import { copyUrl } from '@/utils/copyUrl.js'

export default {
  data() {
    return {
      list: [],
      menulist: [],
      nextDay:
        Date.now() +
        (Date.UTC(
          new Date().getUTCFullYear(),
          new Date().getUTCMonth(),
          new Date().getUTCDate(),
          23,
          59,
          59
        ) -
          Date.now()),
      nextWeek: Date.UTC(
        new Date().getUTCFullYear(),
        new Date().getUTCMonth(),
        new Date().getUTCDate() + ((7 - new Date().getUTCDay()) % 7),
        23,
        59,
        59
      ),
      langData: homeLang[1],
      username: JSON.parse(sessionStorage.getItem('loginData')).agentName,
      code: JSON.parse(sessionStorage.getItem('loginData')).inviteCode,
      iocnsObj: {
        1: 'el-icon-s-home',
        2: 'el-icon-coin',
        3: 'el-icon-coin',
        4: 'el-icon-download',
        5: 'el-icon-coin',
        6: 'el-icon-key',
        7: 'el-icon-time',
        8: 'el-icon-data-line',
      },
      direction: 'ltr',
      drawer: false,
      isCollapse: false,
      activePath: '',
      lang: 1,
      hideAside: false,
      cout: 0,
      dialogVisible: false,
    }
  },
  computed: {
    dayCountdownFormat() {
      return this.lang === 2 
        ? `ss[${this.langData.second}]:mm[${this.langData.minute}]:HH[${this.langData.hour}]`
        : `HH[${this.langData.hour}]:mm[${this.langData.minute}]:ss[${this.langData.second}]`;
    },
    weekCountdownFormat() {
      return this.lang === 2 
        ? `ss[${this.langData.second}]:mm[${this.langData.minute}]:HH[${this.langData.hour}]:DD[${this.langData.day}]`
        : `DD[${this.langData.day}]:HH[${this.langData.hour}]:mm[${this.langData.minute}]:ss[${this.langData.second}]`;
    }
  },
  created() {
    this.lang = parseInt(sessionStorage.getItem('lang')) || 0
    this.saveNavState(this.$route.path)
    this.activePath = window.sessionStorage.getItem('activePath') || '/baseInfo/agency'
    this.getHostListData()
    this.menulist = this.getMenuList(this.lang)
    this.langData = homeLang[this.lang]
  },
  methods: {
    mCopyUrl() {
      copyUrl(this.code)
      this.$message({
        message: 'copy success',
        center: true,
        type: 'success',
      })
    },
    async getHostListData() {
      const { data: res } = await count_unreadMsg({
        agent_id: JSON.parse(sessionStorage.getItem('loginData')).agentId,
      })
      this.cout = res.data.data
    },
    goEdit() {
      this.$router.push('/resetPsw')
    },
    async query() {
      const { data: res } = await query_unreadMsg({
        agent_id: JSON.parse(sessionStorage.getItem('loginData')).agentId,
      })
      this.list = res.data
    },
    handleClose() {
      this.dialogVisible = false
    },
    round() {
      this.query()
      this.dialogVisible = true
    },
    async logout() {
      window.sessionStorage.clear()
      location.reload()
    },
    toggleCollapse() {
      this.drawer = true
    },
    saveNavState(activePath, type) {
      if (type == 2) {
        this.drawer = false
      }
      if(activePath == '/home'){
        activePath = '/baseInfo/agency'
      }
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    },
    switchLang() {
      window.sessionStorage.setItem('lang', this.lang)
      this.$store.state.lang = this.lang
      this.langData = homeLang[this.lang]
      this.menulist = this.getMenuList(this.lang)
    },
    getMenuList(lang) {
      const menus = {
        0: [
          {
            authName: 'Basic Information',
            id: 1,
            order: 1,
            path: 'baseInfo',
            children: [
              {
                id: 31,
                authName: 'Agency',
                path: '/baseInfo/agency',
                order: null,
              },
              {
                id: 32,
                authName: 'Host',
                path: '/baseInfo/host',
                order: null,
              },
            ],
          },
          {
            authName: 'Reports',
            id: 8,
            order: 1,
            path: 'report',
            children: [
              {
                id: 33,
                authName: 'Daily Report',
                path: '/report/total_income',
                order: null,
              },
              {
                id: 34,
                authName: 'Weekly Report',
                path: '/report/total_income_week',
                order: null,
              },
              {
                id: 35,
                authName: 'Salary Report',
                path: '/report/settlement_detail',
                order: null,
              },
            ],
          },
          {
            authName: 'Ban Records',
            id: 7,
            order: 1,
            path: 'block',
            children: [
              {
                id: 33,
                authName: 'Ban Records',
                path: '/block/block',
                order: null,
              },
            ],
          },
        ],
        1: [
          {
            authName: '基本信息',
            id: 1,
            order: 1,
            path: 'baseInfo',
            children: [
              {
                id: 31,
                authName: '代理',
                path: '/baseInfo/agency',
                order: null,
              },
              {
                id: 32,
                authName: '主播',
                path: '/baseInfo/host',
                order: null,
              },
            ],
          },
          {
            authName: '报表',
            id: 8,
            order: 1,
            path: 'report',
            children: [
              {
                id: 33,
                authName: '日报表',
                path: '/report/total_income',
                order: null,
              },
              {
                id: 34,
                authName: '周报表',
                path: '/report/total_income_week',
                order: null,
              },
              {
                id: 35,
                authName: '结算报表',
                path: '/report/settlement_detail',
                order: null,
              },
            ],
          },
          {
            authName: '封禁记录',
            id: 7,
            order: 1,
            path: 'block',
            children: [
              {
                id: 33,
                authName: '封禁记录',
                path: '/block/block',
                order: null,
              },
            ],
          },
        ],
        2: [
          {
            authName: 'معلومات أساسية',
            id: 1,
            order: 1,
            path: 'baseInfo',
            children: [
              {
                id: 31,
                authName: 'وكالة',
                path: '/baseInfo/agency',
                order: null,
              },
              {
                id: 32,
                authName: 'مضيفة',
                path: '/baseInfo/host',
                order: null,
              },
            ],
          },
          {
            authName: 'تقارير',
            id: 8,
            order: 1,
            path: 'report',
            children: [
              {
                id: 33,
                authName: 'تقرير يومي',
                path: '/report/total_income',
                order: null,
              },
              {
                id: 34,
                authName: 'تقرير أسبوعي',
                path: '/report/total_income_week',
                order: null,
              },
              {
                id: 35,
                authName: 'تقرير التسوية',
                path: '/report/settlement_detail',
                order: null,
              },
            ],
          },
          {
            authName: 'سجلات الحظر',
            id: 7,
            order: 1,
            path: 'block',
            children: [
              {
                id: 33,
                authName: 'سجلات الحظر',
                path: '/block/block',
                order: null,
              },
            ],
          },
        ],
        3: [
          {
            authName: 'Información Básica',
            id: 1,
            order: 1,
            path: 'baseInfo',
            children: [
              {
                id: 31,
                authName: 'Agencia',
                path: '/baseInfo/agency',
                order: null,
              },
              {
                id: 32,
                authName: 'Anfitriona',
                path: '/baseInfo/host',
                order: null,
              },
            ],
          },
          {
            authName: 'Informes',
            id: 8,
            order: 1,
            path: 'report',
            children: [
              {
                id: 33,
                authName: 'Informe Diario',
                path: '/report/total_income',
                order: null,
              },
              {
                id: 34,
                authName: 'Informe Semanal',
                path: '/report/total_income_week',
                order: null,
              },
              {
                id: 35,
                authName: 'Informe de Nómina',
                path: '/report/settlement_detail',
                order: null,
              },
            ],
          },
          {
            authName: 'Registro de Bloqueos',
            id: 7,
            order: 1,
            path: 'block',
            children: [
              {
                id: 33,
                authName: 'Registro de Bloqueos',
                path: '/block/block',
                order: null,
              },
            ],
          },
        ],
      }
      return menus[lang]
    },
  },
}
</script>

<style lang="scss" scoped>
.home-container {
  height: 100%;
  font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

.el-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  background-color: #373d41;
  color: #fff;
  font-size: 20px;
  padding: 0;
  height: max-content !important;
  font-family: 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial;
}

.smallshow {
  display: flex;
  width: 100vw;
  justify-content: space-between;
  align-items: center;
  .items {
    width: 100%;
  }
  .time-wrapper {
    display: flex;
    flex-direction: column;
  }
}

.heald-btn {
  margin: 10px 20px;
}

.el-select {
  width: 100px;
  margin-right: 15px;
}

.totle {
  width: 100%;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  color: #fff;

  img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }
}

.totle2 {
  text-align: center;
  color: #fff;

  span {
    color: #ff0000;
  }
}

.el-aside {
  background-color: #333744;

  .el-menu {
    border-right: none;
  }
}

.el-menu {
  border-right: none;
}

.el-main {
  background-color: #eaedf1;
}

.el-main-xs {
  padding: 0;
}

.iconfont {
  margin-right: 13px;
}

.toggle-button {
  width: 50px;
  background-color: #4a5064;
  font-size: 10px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
  height: 40px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

/*fade*/
.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.5s;
}

.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-move {
  transition: all 0.5s;
}

.breadcrumb-leave-active {
  position: absolute;
}

.homebtn {
  width: 100%;
  margin: 8px auto;
  text-align: center;
}

.xs-menu {
  width: 265px;
  background-color: #333744;
  height: 100vh;
}

.drawer-mecss {
  background-color: #333744;
}

.ps {
  margin: 0 0 20px;

  p {
    width: 1000px;
    margin: 0 auto 10px;
  }
}

.div {
  font-size: 16px;
  margin: 0 0 20px;
  display: flex;

  > :nth-child(2) {
    margin: 0 20px;

    > div {
      margin: 10px 0 0;
      line-height: 25px;
    }
  }
}

.er {
  cursor: pointer;
}
</style>
<style scoped lang="scss">
.time-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: max-content;
}

.time-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.time-wrapper-small {
  font-size: 18px;
}

:deep(.el-statistic) {
  .number {
    font-size: 18px;
  }
}

.statistic-wrapper {
  display: inline-block;
  margin-right: 10px;
}
</style>